/**
 * Represents the application type.
 */
export type ApplicationType = 'saas' | 'disco';

export const APPLICATION_TYPE = {
  SAAS: 'saas' as ApplicationType,
  DISCO: 'disco' as ApplicationType,
};
